/* Babel polyfill stuff */
import 'core-js/stable';
import 'regenerator-runtime/runtime';

/* Custom polyfills */
import './polyfills/profet-polyfills';

/* Main scss file */
import './../scss/app.scss';

/* Main Vue file */
//import './vue/vue-app.js';

/* Add your other imports here */
import './navigation';
